export default __webpack_public_path__ + "static/media/map.20ee6965.svg";